<!--
================================================
Composant gérant le formulaire de réinitialisation du mot de passe
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="PwdResetComp">
        <div class="columns mainContainer">

            <div class="column"></div>
            <div class="column is-three-quarters formColumn">

                <div class="columns">
                    <div class="column"></div>

                    <div class="column is-9 columnCont">
                        <img src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="logo">
                        <!--Formulaire de demande-->
                        <div class="contForm" v-if="!requestAchieved">
                            <!--<form action="" v-on:keyup.enter="validateBeforeSubmit"> !! bug étrange qui refresh la page avec ce code (mais qui fonctionne dans login/signup-->
                            <form action="" v-on:submit.prevent="validateBeforeSubmit"  v-on:keyup.enter="validateBeforeSubmit">

                                <h1 class="is-size-4">{{ $t("RéinitialisationDuMotDePasse") }}</h1>

                                <div class="field">
                                    <div class="control">

                                        <!--ce champ hidden sert pour l'accéssibilité (https://www.chromium.org/developers/design-documents/create-amazing-password-forms)-->
                                        <input id="username4Manager" type="text" style="display:none" autocomplete="username" v-bind:value="email">

                                        <input class="input"
                                               v-model="reset_password" v-validate="'required|min:6|max:20'"  id="reset_password"
                                               name="pwdReset_password" type="password" v-bind:placeholder="$t('NouveauMotDePasse')"
                                               autocomplete="new-password" ref="pwdReset_password"
                                               v-bind:disabled="!tokenIsValid">
                                    </div>
                                    <p class="help is-danger has-text-left" id="error_pwdReset_password">{{
                                        errors.first('pwdReset_password') }}</p>
                                </div>

                                <div class="field">
                                    <div class="control">
                                        <input class="input"
                                               v-model="reset_password_confirm" v-validate="'required|confirmed:pwdReset_password'"
                                               id="pwdReset_password_confirm" name="pwdReset_password_confirm"
                                               type="password" v-bind:placeholder="$t('Confirmation')" autocomplete="new-password"
                                               v-bind:disabled="!tokenIsValid">
                                    </div>
                                    <p class="help is-danger has-text-left" id="error_pwdReset_password_confirm">{{
                                        errors.first('pwdReset_password_confirm') }}</p>
                                </div>

                                <div class="field">
                                    <a v-on:click="validateBeforeSubmit" id="formSubmitBtn"
                                       v-bind:class="{'is-loading':isSubmiting}" class="button  is-fullwidth loginBtn" v-bind:disabled="!tokenIsValid">{{$t("Valider")}}</a>
                                </div>

                            </form>
                        </div>

                        <!--Confirmation de la modification-->
                        <div class="contConfirm" v-if="requestAchieved">
                            <font-awesome-icon :icon="['far', 'check-circle']" size="6x" />
                            <h1 class="is-size-4">
                                {{ $t("ModificationEffectuée") }}
                            </h1>

                            <div class="infoLink">
                                <span v-html="$t('vousPouvezApresentVousConnecter')"></span> <br><br>
                                <router-link id="loginLink" v-bind:to="{ name: 'login'}">{{$t("Connexion")}}</router-link>
                            </div>
                        </div>
                    </div>

                    <div class="column"></div>

                </div>
            </div>
            <div class="column"></div>

        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'SignupComp',
        components: {
        },
        mixins: [GlobalErrorNotification, SentryMixin, TrackingMixin],
        data: function () {
            return {
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission
                requestAchieved: false, // true si la requête de réinitialisation a été effectuée avec succès

                reset_password: '',         // le nouveau mot de passe
                reset_password_confirm: '',  // le nouveau mot de passe

                token: this.$route.params.token, // le token pour modifier le mpd
                tokenIsValid: false,     // indique si le token est valide (après vérif.)

                email: null     // username du compte passé en url param (utilisé pour le gestionnaire de password du browser + tracking mixpanel)
        }},

        methods: {

            /*
            Envoi la requête pour mettre à jour le de mot de passe
            */
            sendPwdResetQuery(){
                let self = this

                return self.$http
                    .post("public/password/reset", {
                        token: self.token,
                        password1: self.reset_password,
                        password2: self.reset_password_confirm
                    })
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                        if(response.data.message == 'password updated')
                        self.requestAchieved = true;
                        self.ga4GlobalEventTrack('Password updated' , {})

                      self.$mixpanel.track('Password updated', {"email":self.email})
                    })
                    .catch(function (error) {
                        self.logToSentry(self, error, 'error')
                        let errorCode = '0007'
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$gtag.exception({'description': 'error '+errorCode + ' | error in password reset query', 'fatal': false})
                      self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in password reset query"})
                        self.$sentry.captureMessage(`Error ${errorCode} > error in password reset query : ${error}`, 'error')
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })


            },

            /*
             * Valide le formulaire avant sa soumission
             */
            validateBeforeSubmit() {
                if (this.tokenIsValid) { // empêche la soumission du form si token non valide
                    this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                    this.isSubmiting = true;

                    let self = this
                    this.$validator.validateAll().then((result) => {
                        if (result) { // si la validation. réussie
                            self.sendPwdResetQuery();
                            self.ga4GlobalEventTrack('Password reseted' , {})

                        }
                        else { // si il y a des erreurs...
                            self.$store.commit('UpdateGlobalNotificationComp', {
                                'isVisible': true,
                                'color': 'is-danger',
                                'message': self.$t('leFormulaireContientDesErreurs')
                            });
                            self.isSubmiting = false;
                        }

                    })
                }
            },

            /*
             Vérifie la validité du token dans l'url
             */
            checkToken() {
                {
                    let self =this;

                    return this.$http.get("public/password/request/check/"+this.token, {
                        })
                        .then(function (response) {
                            if (response.data.message == "valid token") {
                                self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                              // token ok
                                self.tokenIsValid = true;
                            }
                        })
                        .catch(function (error) {
                            if(error.response.status == 400 && error.response.data.message == 'token is not found'){
                                self.$store.commit('UpdateGlobalNotificationComp', {
                                    'isVisible': true,
                                    'color': 'is-warning',
                                    'message': self.$t('errorLienInvalide')
                                });

                            }    else if(error.response.status == 400 && error.response.data.message == 'token is expired'){
                                self.$store.commit('UpdateGlobalNotificationComp', {
                                    'isVisible': true,
                                    'color': 'is-warning',
                                    'message': self.$t('errorLienExpiré')
                                });
                            }
                            else{
                                self.logToSentry(self, error, 'error')
                                let errorCode = '0008'
                                self.showGlobalErrorNotif(self,errorCode)
                                self.$gtag.exception({'description': 'error '+errorCode + ' | error in checking token query', 'fatal': false})
                              self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in checking token query"})
                                self.$sentry.captureMessage(`Error ${errorCode} > error in checking token query : ${error}`, 'error')
                            }
                        })
                }
            },

            /**
             * Définit la valeur de this.email si un paramètre email est présent dans l'url
             */
            preFillEmailUsername(){
                if(this.$route.query.email){
                    this.email = this.$route.query.email

                }
            }

        },

        computed: mapState({}),

        created: function () {
        },
        mounted: function () {
            this.checkToken()
            this.preFillEmailUsername()
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    .column {
    }

    .mainContainer {
        @include mobile {
            padding: 0 1.5rem;
            margin-top: -3rem;
        }
    }

    .formColumn {
        padding: 3rem 1rem;
        background: #f3f3f3;
        border-radius: 3px;

        .logo {
            margin-bottom: 4rem;
        }

        h1 {
            color: $brandThird;
        }
        .input {
            margin-top: 2rem;
        }
        .loginBtn {
            margin-top: 4rem;
            padding: 2rem 0;
            border: solid 1px transparent;
            background: $brandPrimary;
            color: white;
            &:hover {
                transition: background-color 0.3s;
                background: lighten($brandPrimary, 5%);
                color: white;
            }
            &:active {
                background: $brandBlue;
                transition: background-color 0.1s;
                color: white;
            }

        }
        .infoLink {
            font-style: italic;
            font-size: 0.9rem;
            padding-top: 1rem;
            $color: #839ba6;
            color: $color;
            a {
                color: $color;
                text-decoration: underline
            }
        }

        .columnCont {
            @include mobile {
                padding: 0 2rem;
            }
        }


    }

    .contConfirm{
        .infoLink{
            font-size: 1rem;
            font-style: normal;
            a{ color: $brandBlue}
        }

        .svg-inline--fa{
            color: $brandPrimary;
            margin-bottom: 1rem;
        }

    }

</style>
